import { Input } from 'antd';
import PropTypes from 'prop-types';

const AntdInput = ({ size, ...props }) => {
  return (
    <Input
      {...props}
      size={size === 'xLarge' ? 'large' : size}
      style={{
        fontSize: '16px',
        color: ' #666666',
        borderRadius: 0,
        ...(size === 'xLarge'
          ? {
              padding: '11.5px 20px',
            }
          : {}),
      }}
    />
  );
};

AntdInput.propTypes = {
  size: PropTypes.oneOf(['large', 'small', 'middle', 'xLarge']),
};

AntdInput.defaultProps = {
  size: 'middle',
};

export default AntdInput;
